---
fr:
  personal_tokens:
    connect:
      copy_prompt: Copier l'instruction de connexion
      prompt: 'Connecte-toi au serveur MCP de Kaia Portal. Transport : http. URL : {url}. En-tête : Authorization: Bearer {token}. Puis liste les centrales que tu peux voir.'
      step_copy: Copiez le jeton ci-dessus ; il ne sera plus affiché.
      step_tell: Donnez à votre assistant IA l'adresse MCP {url} et le jeton, puis demandez-lui de se connecter. Ou collez l'instruction prête à l'emploi ci-dessous.
      step_verify: Demandez-lui de lister les centrales qu'il peut voir. Si vous obtenez une liste, vous êtes connecté.
      title: Connecter votre assistant IA
    copy: Copier le jeton
    create: Créer un jeton
    created_title: Jeton créé
    created_warning: Copiez-le maintenant. Ce jeton ne sera plus affiché. Ne le partagez qu'avec l'assistant IA que vous connectez ; en cas de doute, révoquez-le ici et créez-en un nouveau.
    days: "{count} jours"
    done: Terminé
    empty: Aucun jeton pour le moment.
    errors:
      lifetime: La durée de vie doit être de %{allowed} jours
      minting_paused: La création de jetons MCP personnels est suspendue
    expires: Expire le {date}
    hint: Pour les clients MCP agissant en votre nom. Même accès aux centrales que ce compte.
    last_used: Dernière utilisation {date}
    lifetime: Expire dans
    name: Nom du jeton
    name_hint: Nommez-le d’après l’appareil ou le client qui l’utilise.
    never_used: Jamais utilisé
    paused: La création de jetons est suspendue le temps de finaliser l'examen de conformité du serveur MCP. Les jetons existants ont été révoqués. Nous travaillons à son retour.
    revoke: Révoquer
    revoke_named: Révoquer {name}
    revoke_text: "{name} cessera de fonctionner immédiatement. Cette action est irréversible."
    revoke_title: Révoquer le jeton ?
    status:
      active: Actif
      expired: Expiré
      expires_soon: Expire bientôt
      revoked: Révoqué
    title: Jetons d’accès personnels
    toast:
      copied: Jeton copié dans le presse-papiers
      copy_failed: Copie impossible. Sélectionnez le jeton et copiez-le manuellement.
      create_failed: Impossible de créer le jeton
      created: Jeton créé
      load_failed: Impossible de charger les jetons
      prompt_copied: Instruction de connexion copiée dans le presse-papiers
      revoke_failed: Impossible de révoquer le jeton
      revoked: Jeton révoqué
